import WlAddressesData from '@/assets/data/wl-addresses.json';

let WlAddresses = {};

WlAddresses.install = function (Vue) {
  Vue.prototype.$getWl = () => {
    return WlAddressesData;
  };

  Vue.prototype.$getWlAddress = (key) => {
    return WlAddressesData[key];
  };
};
export default WlAddresses;
